(function ($) {
  $(document).ready(function () {
    $('.result-carousel-wrap').appendTo('.product__info-container');
    $('.product-complete-bundle-wrap').appendTo('.product__info-container');
    var $share = $('.product__info-container share-button').first();
    if ($share.length && $('.mermaid-bundle-video').length) {
      $('.mermaid-bundle-video').insertAfter($share);
    }

    function waitForElement(selector, timeout, interval) {
      timeout = timeout || 5000;
      interval = interval || 100;
      var start = Date.now();
      var deferred = $.Deferred();

      (function check() {
        var $el = $(selector);
        if ($el.length) {
          deferred.resolve($el);
        } else if (Date.now() - start >= timeout) {
          deferred.reject(
            new Error('Timeout: ' + selector + ' not found within ' + timeout + 'ms')
          );
        } else {
          setTimeout(check, interval);
        }
      })();

      return deferred.promise();
    }

    $(function () {
      waitForElement('.product__info-wrapper square-placement', 10000, 100)
        .done(function ($square) {
          var $form = $('.product-form');
          $square.insertAfter($form);
          $square.find('.afterpay-logo svg path').attr('fill', '#000');
        })
        .fail(function (err) {
          console.warn(err.message);
        });
    });
  });
})(jQuery);
